import { DraftReturnSchema } from "@redotech/redo-model/draft-return/draft-return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const addDynamicMerchantItemFlow = {
  name: "addDynamicMerchantItemFlow" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    returnableItemId: z.string(),
    returnReasons: z.array(z.string()),
    notes: z.string().nullish(),
    variantExchangeItem: z
      .object({
        variantId: z.string(),
        productId: z.string(),
        preserveProperties: z.boolean(),
        title: z.string(),
        image: z.string(),
        productTitle: z.string(),
      })
      .nullish(),
    previousPendingItemId: z.string().nullish(),
    merchantImages: z.array(z.string()).nullish(),
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
